import { render, staticRenderFns } from "./VoiceRecordStep.vue?vue&type=template&id=0d5bcf95&scoped=true&"
import script from "./VoiceRecordStep.vue?vue&type=script&lang=js&"
export * from "./VoiceRecordStep.vue?vue&type=script&lang=js&"
import style0 from "./VoiceRecordStep.vue?vue&type=style&index=0&id=0d5bcf95&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5bcf95",
  null
  
)

export default component.exports